(function () {
  // Fill in the Stripe Payment Link for each flavor + interval.
  const CATALOG = {
    "protein-banana": {
      price: "€44.99",
      save: "10%",
      frequencies: {
        4: "https://buy.stripe.com/00w3cv0ore4z66pdAG1ZS0k",
        6: "https://buy.stripe.com/cNifZh4EHe4zeCVcwC1ZS0n",
        8: "https://buy.stripe.com/00wfZh0orf8D9iB4061ZS0m",
        12: "https://buy.stripe.com/8x28wP3AD9Oj3YhfIO1ZS0l",
      },
    },
    "protein-mango": {
      price: "€44.99",
      save: "10%",
      frequencies: {
        4: "https://buy.stripe.com/eVqeVdefh1hN8exbsy1ZS0g",
        6: "https://buy.stripe.com/eVq3cvfjl6C752l7ci1ZS0j",
        8: "https://buy.stripe.com/eVqfZh8UX3pV0M54061ZS0i",
        12: "https://buy.stripe.com/4gM14n5ILgcHeCV0NU1ZS0h",
      },
    },
    "protein-chocolate": {
      price: "€44.99",
      save: "10%",
      frequencies: {
        4: "https://buy.stripe.com/fZu9ATb35gcH2Ud4061ZS0c",
        6: "https://buy.stripe.com/28EfZh8UXbWreCV68e1ZS0d",
        8: "https://buy.stripe.com/4gMfZh9Z1bWrfGZgMS1ZS0e",
        12: "https://buy.stripe.com/6oUbJ1efh2lR9iBeEK1ZS0f",
      },
    },
    "protein-vanilla": {
      price: "€44.99",
      save: "10%",
      frequencies: {
        4: "https://buy.stripe.com/14AeVdfjl5y39iBaou1ZS08",
        6: "https://buy.stripe.com/00w00jc796C7cuN2W21ZS0b",
        8: "https://buy.stripe.com/14AfZh5IL9Oj7atbsy1ZS09",
        12: "https://buy.stripe.com/dRmfZh6MP5y352lfIO1ZS0a",
      },
    },
    "preworkout-strawberry": {
      price: "€29.99",
      save: "14%",
      frequencies: {
        4: "https://buy.stripe.com/4gM4gzdbdaSn3Yh7ci1ZS01",
        6: "https://buy.stripe.com/bJeaEX7QTgcH9iB9kq1ZS03",
        8: "https://buy.stripe.com/5kQ5kD0or2lRfGZ9kq1ZS02",
      },
    },
    "preworkout-banana": {
      price: "€29.99",
      save: "14%",
      frequencies: {
        4: "https://buy.stripe.com/4gMbJ14EH1hN2Ud1RY1ZS04",
        6: "https://buy.stripe.com/3cIbJ18UX9Oj7atbsy1ZS06",
      },
    },
  };

  const catalogKey = (handle, title) => {
    const hay = `${handle} ${title}`.toLowerCase();
    const isPre = /pre[-_ ]?work/.test(hay);
    let flavor = "";
    if (/strawberr|aardbei/.test(hay)) flavor = "strawberry";
    else if (/chocol/.test(hay)) flavor = "chocolate";
    else if (/mango/.test(hay)) flavor = "mango";
    else if (/vanill/.test(hay)) flavor = "vanilla";
    else if (/banana|banaan/.test(hay)) flavor = "banana";
    if (!flavor) return "";
    return isPre ? `preworkout-${flavor}` : `protein-${flavor}`;
  };

  const init = (widget) => {
    if (!widget || widget.dataset.ready === "true") return;

    const plan = CATALOG[catalogKey(widget.dataset.productHandle, widget.dataset.productTitle)];
    if (!plan) {
      widget.hidden = true;
      return;
    }

    widget.dataset.ready = "true";

    const oneTimePrice = widget.querySelector('[data-purchase-type="one-time"] .option-price');
    const subscriptionPrice = widget.querySelector('[data-purchase-type="subscription"] .option-price');
    const subscriptionBadge = widget.querySelector('[data-purchase-type="subscription"] .option-badge');
    const subscriptionRadio = widget.querySelector('[data-purchase-type="subscription"] .option-radio');
    const frequencySelect = widget.querySelector(".frequency-dropdown");

    if (widget.dataset.oneTimePrice) {
      oneTimePrice.textContent = widget.dataset.oneTimePrice;
    }
    subscriptionPrice.textContent = plan.price;
    subscriptionBadge.textContent = plan.save ? `Save ${plan.save}` : "";

    const weeks = Object.keys(plan.frequencies);
    frequencySelect.innerHTML = weeks
      .map((week) => `<option value="${week}">${week} WEEKS</option>`)
      .join("");
    frequencySelect.value = weeks.includes("4") ? "4" : weeks[0];

    const stripeUrl = () => plan.frequencies[frequencySelect.value] || "";

    document.addEventListener(
      "submit",
      (event) => {
        if (!subscriptionRadio.checked) return;
        if (!event.target.matches?.('form[action*="/cart/add"]')) return;
        const url = stripeUrl();
        if (!url) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(url);
      },
      true,
    );
  };

  const start = () => {
    document.querySelectorAll("[data-subscription-widget]").forEach(init);
  };

  start();
  document.addEventListener("shopify:section:load", start);
})();
